import type { SharedTypes } from '@semios/app-platform-banyan-route-definitions'
import type { TIrrigationZoneEmitter, TPoint } from 'stores/fieldAssetStore/helperTypes'
import { getIrrigationZoneEmitterExternalVendorNames } from './getIrrigationZoneEmitterExternalVendorNames'

export const getExternalVendorNamesByIrrigationZoneId = ({
  irrigationZoneEmitters,
  points,
}: {
  irrigationZoneEmitters: Pick<
    TIrrigationZoneEmitter,
    'externalVendorNames' | 'irrigationZoneEmitterId' | 'irrigationZoneId'
  >[]
  points: Pick<TPoint, 'externalVendorNamesByValueType' | 'irrigationEmitterZoneIds'>[]
}) => {
  const externalVendorNamesByZoneId: Record<number, SharedTypes.IrrigationScheduler.EIrrigationVendorName[]> =
    {}

  irrigationZoneEmitters.forEach((irrigationZoneEmitter) => {
    const { irrigationZoneId } = irrigationZoneEmitter

    externalVendorNamesByZoneId[irrigationZoneId] = [
      ...new Set([
        ...(externalVendorNamesByZoneId[irrigationZoneId] ?? []),
        ...getIrrigationZoneEmitterExternalVendorNames({ irrigationZoneEmitter, points }),
      ]),
    ]
  })

  return externalVendorNamesByZoneId
}
